import "./_slider-styles.scss";

import './slider';
